import palette from '../theme/palette'
import {
  getBorderRadius,
  getFontSize,
  getFontWeight,
  getLineHeight,
  getSpacing,
} from '../theme/comprehensive-theme'

export const inputStyles = {
  fontWeight: getFontWeight('regular'),
  fontSize: getFontSize('sm'),
  lineHeight: getLineHeight('normal'),
  letterSpacing: '0.04em',
  color: palette?.black?.plus10,
  height: 'auto',
  padding: getSpacing('input'),
  border: `1px solid ${palette?.black?.plus85}`,
  borderRadius: getBorderRadius('small'),
}
